import { SPACE_SUBSCRIPTION_GRAPH_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { SpaceSubscriptionGraphData } from 'core/models/Space'

const initialState: { spaceSubscriptionGraph: SpaceSubscriptionGraphData | null, isLoading: boolean } = {
  spaceSubscriptionGraph: null,
  isLoading: false,
}

interface ActionType extends Action {
  payload: {
    spaceSubscriptionGraph: SpaceSubscriptionGraphData;
  }
}

export default function spaceSubscriptionGraphReducer(state = initialState, action: ActionType) {
  switch (action.type) {
    case SPACE_SUBSCRIPTION_GRAPH_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case SPACE_SUBSCRIPTION_GRAPH_ACTION.SUCCESS:
      const { spaceSubscriptionGraph } = action.payload;
      return { ...state, spaceSubscriptionGraph, isLoading: false }

    case SPACE_SUBSCRIPTION_GRAPH_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}